import { useState } from "react";
import { motion } from "framer-motion";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

const SERVICES = ["Tatuagem", "Piercing", "Joias / Acessórios", "Outro"];

const inputCls =
  "w-full bg-[#0A0A0A] border border-white/15 focus:border-[#E60000] outline-none text-white text-sm px-5 py-4 placeholder:text-white/30 transition-colors duration-300";

export const QuoteForm = () => {
  const [form, setForm] = useState({ name: "", phone: "", service: "Tatuagem", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/quotes", form);
      toast.success("Pedido enviado! A equipe Diggy retorna em breve.");
      setForm({ name: "", phone: "", service: "Tatuagem", message: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="orcamento" className="bg-[#171717] py-24 lg:py-32 px-6" data-testid="quote-section">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}>
          <p className="text-xs tracking-[0.3em] font-bold text-[#E60000] mb-3">ORÇAMENTO</p>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white leading-none">
            Conte a sua ideia.<br />
            <span className="italic text-[#E60000]">A gente desenha.</span>
          </h2>
          <p className="mt-6 text-base font-light leading-relaxed text-white/60 max-w-md">
            Preencha ao lado e receba um retorno direto da equipe. Sem compromisso, sem enrolação — do jeito Diggy desde 1998.
          </p>
          <div className="mt-10 space-y-4 text-sm text-white/50">
            <p className="flex items-center gap-3"><span className="w-6 h-px bg-[#E60000]" /> R. Barão do Triunfo, 208 — Bela Vista, Jundiaí/SP</p>
            <p className="flex items-center gap-3"><span className="w-6 h-px bg-[#E60000]" /> Atendimento com hora marcada</p>
            <p className="flex items-center gap-3"><span className="w-6 h-px bg-[#E60000]" /> Materiais 100% descartáveis</p>
          </div>
        </motion.div>

        <motion.form
          onSubmit={submit}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="space-y-5"
          data-testid="quote-form"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <input required value={form.name} onChange={set("name")} placeholder="Seu nome" className={inputCls} data-testid="quote-name-input" />
            <input required value={form.phone} onChange={set("phone")} placeholder="Seu WhatsApp / telefone" className={inputCls} data-testid="quote-phone-input" />
          </div>
          <div className="flex flex-wrap gap-3" data-testid="quote-service-select">
            {SERVICES.map((s) => (
              <button
                type="button"
                key={s}
                onClick={() => setForm((f) => ({ ...f, service: s }))}
                data-testid={`quote-service-${s.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className={`text-xs tracking-[0.15em] font-bold px-5 py-3 border transition-colors duration-300 ${
                  form.service === s
                    ? "bg-[#E60000] border-[#E60000] text-white"
                    : "border-white/20 text-white/60 hover:border-white/60"
                }`}
              >
                {s.toUpperCase()}
              </button>
            ))}
          </div>
          <textarea
            value={form.message}
            onChange={set("message")}
            placeholder="Descreva sua ideia (referências, local do corpo, tamanho...)"
            rows={5}
            className={`${inputCls} resize-none`}
            data-testid="quote-message-input"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="quote-form-submit-button"
            className="btn-sharp w-full flex items-center justify-center gap-3 bg-[#E60000] hover:bg-white hover:text-[#0A0A0A] disabled:opacity-60 text-white text-sm tracking-[0.2em] font-extrabold px-10 py-5 transition-colors duration-300"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Send size={16} />}
            {loading ? "ENVIANDO..." : "ENVIAR PEDIDO DE ORÇAMENTO"}
          </button>
        </motion.form>
      </div>
    </section>
  );
};
